import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, PageHeader } from "@/components/common";

const MAP = {
  "mentions-legales": ["mentions_legales", "Mentions légales"],
  "confidentialite": ["confidentialite", "Politique de confidentialité"],
  "cgv": ["cgv", "Conditions générales de vente"],
  "conditions-reservation": ["conditions_reservation", "Conditions de réservation"],
};

export default function Legal({ page }) {
  const [legal, setLegal] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setLegal(r.data.legal || {})).catch(() => setLegal({})); }, []);
  const [key, title] = MAP[page] || ["", "Informations"];
  const content = legal ? legal[key] : "";
  const empty = !content || content.startsWith("À COMPLÉTER");
  return (
    <div data-testid={`legal-${page}`}>
      <PageHeader eyebrow="Informations" title={title} />
      <Section className="py-20 max-w-3xl">
        {empty ? (
          <div className="card-dark p-10 text-center text-slate-500 text-sm"><span className="font-mono text-xs uppercase tracking-widest text-amber-300">À compléter</span><p className="mt-3">Ce texte juridique sera renseigné depuis l'administration.</p></div>
        ) : (
          <div className="text-slate-300 leading-relaxed whitespace-pre-line">{content}</div>
        )}
      </Section>
    </div>
  );
}
